module.exports = __webpack_public_path__ + "img/social.2052781.svg";